import React from "react";
import { ScrollBar } from "./ScrollBar";
import { Flex } from "rebass";
import _ from "lodash";

export class ScrollPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      scrollTop: 0
    };
    this.handleScrollUpdate = _.throttle(this.handleScrollUpdate, 200);
  }
  handleScrollUpdate = top => {
    if (top !== this.state.scrollTop)
      this.setState({
        scrollTop: top
      });
  };
  onScrollUpdate = ev => {
    this.handleScrollUpdate(ev.top);
  };
  setVerticalScrollPercentage = percentage => {
    if (this.scrollBar) {
      this.scrollBar.setVerticalScrollTopFromPercentage(percentage);
    }
  };
  scrollBar = null;
  render() {
    const { scrollTop } = this.state;
    const { innerRef, children, renderUI, ...props } = this.props;
    let _UI = renderUI;
    if (_.isFunction(renderUI)) {
      _UI = renderUI(scrollTop, this.setVerticalScrollPercentage);
    }
    let _children = children;
    if (_.isFunction(children)) {
      _children = children(scrollTop, this.setVerticalScrollPercentage);
    }
    return (
      <Flex
        flexDirection="column"
        width={1}
        css={`
          position: relative;
          flex-grow: 1;
          height: 100%;
        `}
        {...props}
      >
        {_UI}
        <ScrollBar
          ref={r => {
            this.scrollBar = r;
          }}
          onUpdate={this.onScrollUpdate}
        >
          {_children}
        </ScrollBar>
      </Flex>
    );
  }
}

export default ScrollPage;
